module.exports = __webpack_public_path__ + "img/ogp_makine_big.b5b32e97.jpg";